document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth > 991) {
        $('.why_grootapps-swiper-wrapper').slick({
          slidesToShow: 1,  
          centerMode: true,   
          infinite: false,
          arrows: false,
          dots: false,
          speed: 300,
          cssEase: 'ease',
          autoplay: false,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                variableWidth: false,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 991,
              settings: "unslick"
            }
          ]
        });
      }

    
// accordion JS...
const gApp_option_list = document.querySelectorAll('.why_gApp-option');
const gAppAccordionImages = document.querySelectorAll('.why_gApp-option-image');
const gAppAccordionIconWrappers = document.querySelectorAll('.why_gApp-acoordion-icon-wrap');

// click event..
if (window.innerWidth <= 991) {
    gApp_option_list.forEach((option, index) => {
      option.addEventListener('click', function () {

          
          const currentgAppImg = gAppAccordionImages[index];
          const currentgAppIconWrapper = gAppAccordionIconWrappers[index];
          const currentgAppIconImg = currentgAppIconWrapper?.querySelector('img');
          const minusImg = currentgAppIconWrapper?.dataset.minusimg;
          
          const isActive = option.classList.contains('active');
          
            // first close all..
            gAppAccordionImages.forEach((img, i) => {
            img.classList.remove('active');
            gApp_option_list[i].classList.remove('active');
    
            const iconImg = gAppAccordionIconWrappers[i]?.querySelector('img');
            const plusImg = gAppAccordionIconWrappers[i]?.dataset.plusimg;
            if (iconImg && plusImg) {
                iconImg.src = plusImg;
            }
            });
    
            // if it was NOT active, open it..
            if (!isActive) {
                if (currentgAppImg) currentgAppImg.classList.add('active');;
                option.classList.add('active');
                if (currentgAppIconImg && minusImg) currentgAppIconImg.src = minusImg;
            }
      });
    });
}
});